import type { JSX } from 'react';
import {
  DropdownContainer,
  DropdownLabel,
  DropdownLink,
  DropdownMaxHeight,
  DropdownMenu,
  DropdownOption,
  DropdownOptionContent,
} from '@ardoq/dropdown-2026';
import { HelpActionableItem, HelpItem } from './types';

export type HelpMenuProps = {
  items: HelpItem[];
  onItemSelected: VoidFunction;
};

const HelpMenuDropdownItem = ({
  item,
  onItemSelected,
}: {
  item: HelpActionableItem;
  onItemSelected: VoidFunction;
}) => {
  const content = (
    <DropdownOptionContent
      icon={item.icon}
      label={item.label}
      rightContent={item.rightContent}
      description={item.description}
    />
  );

  if (item.type === 'link') {
    return (
      <DropdownLink
        href={item.href}
        onClick={item.onClick}
        onTrack={item.onTrack}
        target={item.target}
      >
        {content}
      </DropdownLink>
    );
  }

  return (
    <DropdownOption
      onClick={() => {
        onItemSelected();
        item.onTrack?.();
        item.onClick();
      }}
    >
      {content}
    </DropdownOption>
  );
};

export const HelpMenu = ({
  items,
  onItemSelected,
}: HelpMenuProps): JSX.Element => (
  <DropdownContainer dropdownMaxHeight={DropdownMaxHeight.AUTO}>
    <DropdownMenu>
      {items
        .filter(item => item.type !== 'panel-header' && item.type !== 'video')
        .map((item, index) =>
          item.type === 'header' ? (
            <DropdownLabel key={index} variant="header">
              {item.label}
            </DropdownLabel>
          ) : (
            <HelpMenuDropdownItem
              key={index}
              item={item}
              onItemSelected={onItemSelected}
            />
          )
        )}
    </DropdownMenu>
  </DropdownContainer>
);
